import React from "react";

import "./Hero.css";

const Hero = ({ title, subtitle, ctaText, ctaHref, ctaOnClick, badge, compact }) => {
  return (
    <section className={`hero${compact ? " hero--compact" : ""}`}>
      <div className="hero__card">
        <div className="hero__radar" aria-hidden="true">
          <div className="hero__orbit hero__orbit--1">
            <div className="hero__tracer" />
          </div>
          <div className="hero__orbit hero__orbit--2">
            <div className="hero__tracer" />
          </div>
          <div className="hero__orbit hero__orbit--3">
            <div className="hero__tracer" />
          </div>
        </div>

        <div className="hero__content">
          {badge && <span className="hero__badge">{badge}</span>}
          <h1 className="hero__title">{title}</h1>
          <p className="hero__subtitle">{subtitle}</p>
          {ctaText && (
            ctaHref ? (
              <a
                className="hero__cta"
                href={ctaHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                {ctaText}
              </a>
            ) : (
              <button className="hero__cta" onClick={ctaOnClick}>
                {ctaText}
              </button>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
